if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        // Constants
        this.isDisabled = false;
        // Stored elements
        this.form = this.querySelector('form');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.pickSizeButton = this.querySelector('#PickSize__btn');
        this.submitButton = this.querySelector('.add-to-cart__btn');
        this.submitButton__textElements = this.submitButton.querySelectorAll('.button-text');
        this.submitButton__notifyMeOverlay = this.querySelector('.btnOverlay__remindMe');
        this.fieldset = document.querySelector('.sizeSelector__desktopContainer');
        this.infoSelectors = document.querySelector('.sizeSelector__desktopContainer').querySelector('.infoSelectors');

        this.form.querySelector('[name=id]').disabled = false;

        // Assign pick-size-button click event - toggle modal state
        this.pickSizeButton.addEventListener('click', () => ProductSizeSelector.toggleModal(1));

        // Assign submit event to product form
        this.form.addEventListener('submit', (e) => {
          // Prevent default for submittion event
          e.preventDefault();
          // Item is out of stock - return
          if (ProductSizeSelector.isOutOfStock) {
            return;
          }
          //try to add suitcase and regular product together - disabled by Tami request
          // if (cartTagVar !== 0 && cartTagVar !== productTagVar) return this.toggleSuitcaseSheet(true);

          if (e.target['options[size]'] && !selectedSize) {
            // Size not selected
            if (ProductSizeSelector.isMobile()) {
              // Mobile mode - show modal
              ProductSizeSelector.toggleModal(2, true);
            } else {
              // Desktop mode - highlight fieldset error
              this.fieldset.classList.add('err__noSizeChosen');
            }
          } else {
            // Size is selected
            this.clickButton();
            if (selectedSize) {
              const sizeInput = document.getElementById('sizeInput');
              const idInput = document.getElementById('idInput2');
              sizeInput.value = selectedSize.size;
              idInput.value = variantsData.find((vdata) => vdata.option2 == selectedSize.size).id;
            }
            this.onSubmitHandler(e);
          }
        });
        // Initiate submit-button logic
        this.initSubmitButton();

        // Initiate suitcase-sheet logic
        this.initSuitcaseSheet();

        // Bind removeClickUpdater to "this" and make a constant reference to the event handler
        this.updateSelectionCartStatus__removeClickUpdater = this.removeClickUpdater.bind(this);

        // Update selection cart status
        this.updateSelectionCartStatus();
        setInterval(() => {
          this.updateSelectionCartStatus();
        }, 1000);
      }

      /*
       * Method initiates the functionallity for the product-form : submit-button logic.
       */
      initSubmitButton() {
        // Set submit-attribute if 'card-drawer' exists
        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        // Click button on spacebar or return keypress
        document.body.onkeyup = function (evt) {
          if (evt.keyCode == 13 || evt.keyCode == 32) {
            this.clickButton();
          }
        };
        // Set up button text transition timings on page load
        this.submitButton__textElements.forEach((element) => {
          const characters = element.innerText.split('');
          let characterHTML = '';
          characters.forEach((letter, index) => {
            characterHTML += `<span class="char${index}" style="--d:${index * 30}ms; --dr:${
              (characters.length - index - 1) * 30
            }ms;">${letter}</span>`;
          });
          element.innerHTML = characterHTML;
        });
        // Assign click event to add-to-cart-btn : notify-me-overlay - open restock rocket modal
        this.submitButton__notifyMeOverlay.addEventListener('click', function (evt) {
          evt.stopPropagation();
          ProductSizeSelector.openRestockRocketModal();
        });
      }

      /*
       * Method handles the button click style functionallity.
       */
      clickButton() {
        if (!this.isDisabled) {
          this.isDisabled = true;
          // Loading stage
          this.submitButton.classList.add('addToCart__loading');
          this.submitButton.classList.remove('addToCart__ready');
          setTimeout(() => {
            // Completed stage
            this.submitButton.classList.add('addToCart__complete');
            this.submitButton.classList.remove('addToCart__loading');
            setTimeout(() => {
              setTimeout(() => {
                // Reset button to allow the user to select it again
                this.isDisabled = false;
                this.submitButton.classList.add('addToCart__ready');
                this.submitButton.classList.remove('addToCart__complete');
              }, 3800);
            }, 1);
          }, 600);
        }
      }

      /*
       * Method clears any selected size from the sizes form.
       */
      clearSelectedSize() {
        this.infoSelectors.innerHTML = '';
        document.querySelectorAll('.sizeSelector__btn').forEach((button) => {
          button.classList.remove('sizeSelector__btn-active');
        });
        selectedSize = null;
      }

      /*
       * Method updates cart data, resetting selections and refreshes the UI.
       */
      removeClickUpdater() {
        setTimeout(() => {
          fetch(window.location.origin + '/cart.js')
            .then((response) => response.json())
            .then((data) => {
              // Update products quantities
              productsQuantity = data.items
                .map((ci) => ({ [ci.id]: ci.quantity ?? 0 }))
                .reduce(
                  (accumulator, currentObject) => ({
                    ...accumulator,
                    ...currentObject,
                  }),
                  {}
                );

              // Update stock
              stockData = Object.keys(stockData)
                .map((s) => ({
                  [s]: stockDataGlobal[s] - (productsQuantity[s] ?? 0),
                }))
                .reduce(
                  (accumulator, currentObject) => ({
                    ...accumulator,
                    ...currentObject,
                  }),
                  {}
                );

              // Clear selected size
              this.clearSelectedSize();

              // Rerender size-selector
              ProductSizeSelector.renderSizeSelector();

              // Check if there is a suitcase together with normal item
              let suitcaseMismatchAfterUpdate;
              if (productTagVar == 2) {
                suitcaseMismatchAfterUpdate = suitcaseProductIds.some((id) => Object.keys(stockData).includes(id));
              } else {
                suitcaseMismatchAfterUpdate = nonSuitcaseProductIds.some((id) => Object.keys(stockData).includes(id));
              }
              if (!suitcaseMismatchAfterUpdate) {
                cartTagVar = 0;
              }
            });
        }, 1000);
      }

      /*
       * Method updates the selection cart status.
       */
      updateSelectionCartStatus() {
        var cardDrawer = document.getElementById('CartDrawer-Form');
        if (!cardDrawer) {
          return setTimeout(() => {
            this.updateSelectionCartStatus();
          }, 1000);
        }
        cardDrawer.removeEventListener('click', this.updateSelectionCartStatus__removeClickUpdater);
        cardDrawer.addEventListener('click', this.updateSelectionCartStatus__removeClickUpdater);
      }

      /*
       * Method handles a product form submittion.
       * @param evt - the event passed form the submittion.
       */
      onSubmitHandler(evt) {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.id) {
              const sizeInput = document.getElementById('sizeInput')?.value;
              if (sizeInput) {
                productsQuantity[response.id] = 1 + (productsQuantity[response.id] ?? 0);

                // Update stock list
                stockData[response.id] = stockDataGlobal[response.id] - (productsQuantity[response.id] ?? 0);

                // Rerender new states
                ProductSizeSelector.renderSizeSelector(true);
                setTimeout(() => {
                  this.updateSelectionCartStatus();
                }, 2500);
              }
            }
            if (response.status) {
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (stockData[response.id] < 1) {
              // Clear selected size when reached 0 amount
              this.clearSelectedSize();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  }, 3000);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              setTimeout(() => {
                this.cart.renderContents(response);
                // clear any errors & messages, reset active size buttons if size reached zero
                // if (stockData[response.id] < 1) {
                //   this.clearSelectedSize()
                // }
              }, 2300);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            this.submitButton.setAttribute('aria-disabled', false);
          });
      }

      /*
       * Method initialize the suitcase bottom sheet.
       */

      initSuitcaseSheet() {
        let suitcaseSheetStart;
        let suitcaseSheetEnd;
        const suitcaseSheetWrapper = document.querySelector('.suitcase-sheet__wrapper');
        const suitcaseSheetContainer = suitcaseSheetWrapper.querySelector('.suitcase-sheet');

        const suitcaseSheetHeader = suitcaseSheetContainer.querySelector('.suitcase-sheet__header');
        const suitcaseSheetX = suitcaseSheetContainer.querySelector('.suitcase-sheet__x');
        suitcaseSheetWrapper.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target == suitcaseSheetWrapper) this.toggleSuitcaseSheet(false);
        });
        suitcaseSheetX.addEventListener('click', () => {
          this.toggleSuitcaseSheet(false);
        });
        suitcaseSheetHeader.addEventListener('touchstart', (e) => {
          suitcaseSheetStart = e.touches[0].clientY;
          suitcaseSheetContainer.style.transition = 'none';
        });

        suitcaseSheetHeader.addEventListener('touchmove', (e) => {
          e.stopPropagation();
          suitcaseSheetEnd = e.touches[0].clientY;
          const RdeltaY = suitcaseSheetEnd - suitcaseSheetStart;
          if (RdeltaY > 0) {
            suitcaseSheetContainer.style.transform = `translateY(${RdeltaY}px)`;
          }
        });

        suitcaseSheetHeader.addEventListener('touchend', (e) => {
          const RdeltaY = suitcaseSheetEnd - suitcaseSheetStart;
          if (RdeltaY > 220) {
            this.toggleSuitcaseSheet(false);
            suitcaseSheetContainer.style = '';
          } else {
            suitcaseSheetContainer.style = '';
          }
        });

        document.querySelector('.suitcase-sheet__checkout-link').addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleSuitcaseSheet(false);
          setTimeout(() => {
            this.cart.open();
          }, 500);
        });
      }

      /*
       * Method toggle the suitcase bottom sheet.
       */
      toggleSuitcaseSheet(open) {
        return;
        const suitcaseSheetWrapper = document.querySelector('.suitcase-sheet__wrapper');
        if (open) {
          document.querySelector('.suitcase-sheet__title').innerText =
            productTagVar == 1 ? 'שמנו 💛 שיש לך מוצרים בסל' : 'שמנו 💛 שיש לך מזוודה בסל';
          document.querySelector('.suitcase-sheet__description').innerText =
            productTagVar == 1
              ? 'אבל הכל טוב! אפשר לסיים את ההזמנה הנוכחית, ואז לחזור לאתר ולהזמין את המזוודה.'
              : 'אבל הכל טוב! אפשר לסיים את הזמנת המזוודה שבסל שלך, ואז לחזור לאתר ולהזמין את שאר המוצרים.';
          setTimeout(() => {
            document.querySelector(`.suitcase-sheet`).classList.add('suitcase-sheet--open');
            window.requestAnimationFrame(() => {
              suitcaseSheetWrapper.classList.add('suitcase-sheet__wrapper--open');
            });

            document.body.style.overflow = 'hidden';
          }, 250);
        } else {
          suitcaseSheetWrapper.classList.remove('suitcase-sheet__wrapper--open');
          setTimeout(() => {
            document.querySelectorAll(`.suitcase-sheet`).forEach((bs) => {
              bs.classList.remove('suitcase-sheet--open');
            });
          }, 400);
          document.body.style.overflowY = 'auto';
        }
      }

      /*
       * Method handles error messages in product form.
       */
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
